




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import * as api from '@/services/ApiService'
import appManager from '@/services/AppManager'
import { isBlank, isValidEmail, validatePassword } from '@/core/Utils'
import { UserRole } from '@/core/Types'
import FormTextField from '@/components/FormTextField.vue'
import { getUserRoleDescription, getUserRoleTitle } from '@/model/Helpers'
import { extractResponseErrorMessage } from '@/services/ApiService'

@Component({
    components: {
        FormTextField
    }
})
export default class CreateUserDialog extends Vue {
    @Prop()
    value: boolean|undefined // true to show the dialog
    @Prop()
    companyId: string|undefined
    @Prop()
    onCloseRequested: (() => void)|undefined
    firstName: string|null = null
    firstNameErrorMessage: string|null = null
    lastName: string|null = null
    lastNameErrorMessage: string|null = null
    email: string|null = null
    emailErrorMessage: string|null = null
    password: string|null = null
    passwordErrorMessage: string|null = null
    roles: UserRole[] = []
    role: UserRole|null = null
    roleErrorMessage: string|null = null
    formErrorMessage: string|null = null
    isCreating: boolean = false

    // noinspection JSUnusedGlobalSymbols
    created() {
        const user = appManager.userManager.state?.user
        if (user) {
            this.roles = []
            if (user.data.role === UserRole.ADMIN)
                this.roles.push(UserRole.ADMIN)
            if (user.data.role === UserRole.COMPANY_OWNER)
                this.roles.push(UserRole.COMPANY_OWNER)
            this.roles.push(UserRole.USER)
        }
    }

    getUserRoleTitleLocal(role: UserRole): string {
        return getUserRoleTitle(role)
    }

    getUserRoleDescriptionLocal(role: UserRole): string {
        return getUserRoleDescription(role)
    }

    onCancelPressed() {
        if (this.onCloseRequested)
            this.onCloseRequested()
    }

    async onCreatePressed(): Promise<void> {
        this.validatePage()
        if (this.formErrorMessage)
            return

        this.isCreating = true

        try {
            await api.createUser({
                firstName: this.firstName!,
                lastName: this.lastName!,
                email: this.email!,
                password: this.password!,
                companyId: this.companyId,
                role: this.role!
            })

            this.formErrorMessage = null

            if (this.onCloseRequested)
                this.onCloseRequested()

            appManager.alertManager.publishSuccess('User successfully added')
        } catch (error) {
            this.formErrorMessage = extractResponseErrorMessage(error) || 'Error creating company. Please try again later.'
        }

        // go ahead and log in
        this.isCreating = false
    }

    validatePage() {
        // your info
        this.firstNameErrorMessage = isBlank(this.firstName) ? 'Specify a first name' : null
        this.lastNameErrorMessage = isBlank(this.lastName) ? 'Specify a last name' : null
        this.emailErrorMessage = !isValidEmail(this.email) ? 'Specify a valid email address' : null
        this.passwordErrorMessage = validatePassword(this.password)
        this.roleErrorMessage = (!this.role) ? 'Specify a user role' : null

        const hasError = !!this.firstNameErrorMessage ||
            !!this.lastNameErrorMessage ||
            !!this.emailErrorMessage ||
            !!this.passwordErrorMessage ||
            !!this.roleErrorMessage
        this.formErrorMessage = hasError ? 'Please correct the error above' : null
    }
}
